module.exports = __webpack_public_path__ + "static/img/QYZ.825dbf8c.png";